var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSweepsColoured = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28201_15010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20.5195C22.7625 20.5195 25.0098 18.2723 25.0098 15.5098C25.0098 12.7472 22.7625 10.5 20 10.5C17.2375 10.5 14.9902 12.7472 14.9902 15.5098C14.9902 18.2723 17.2375 20.5195 20 20.5195ZM19.4434 12.8291V12.1699C19.4434 11.8622 19.6923 11.6133 20 11.6133C20.3077 11.6133 20.5566 11.8622 20.5566 12.1699V12.8277C20.7885 12.9097 21.003 13.0372 21.1818 13.2164C21.3981 13.4338 21.3981 13.7866 21.1807 14.0035C20.9633 14.2198 20.6099 14.2209 20.3925 14.0024C20.0739 13.6816 19.4434 13.9404 19.4434 14.3965C19.4434 14.7036 19.6934 14.9531 20 14.9531C20.9208 14.9531 21.6699 15.7022 21.6699 16.623C21.6699 17.3478 21.2032 17.9599 20.5566 18.1904V18.8496C20.5566 19.1573 20.3077 19.4062 20 19.4062C19.6923 19.4062 19.4434 19.1573 19.4434 18.8496V18.1918C19.2115 18.1098 18.997 17.9823 18.8182 17.8032C18.6019 17.5857 18.6019 17.2329 18.8193 17.016C19.0367 16.7997 19.3901 16.7986 19.6075 17.0171C19.9261 17.3373 20.5566 17.0791 20.5566 16.623C20.5566 16.3159 20.3066 16.0664 20 16.0664C19.0792 16.0664 18.3301 15.3173 18.3301 14.3965C18.3301 13.6717 18.7968 13.0597 19.4434 12.8291Z",
    fill: "#F37AAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9434 28.3867H28.3496V27.8301C28.3496 27.5224 28.1006 27.2734 27.793 27.2734H12.207C11.8994 27.2734 11.6504 27.5224 11.6504 27.8301V28.3867H11.0566C10.749 28.3867 10.5 28.6357 10.5 28.9434C10.5 29.251 10.749 29.5 11.0566 29.5H28.9434C29.251 29.5 29.5 29.251 29.5 28.9434C29.5 28.6357 29.251 28.3867 28.9434 28.3867Z",
    fill: "#F37AAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8965 21.6328H27.2363V26.1602H23.8965V21.6328Z",
    fill: "#F37AAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3301 21.6328H21.6699V26.1602H18.3301V21.6328Z",
    fill: "#F37AAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7637 21.6328H16.1035V26.1602H12.7637V21.6328Z",
    fill: "#F37AAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5087 20.5195H28.9429C29.1353 20.5195 29.3147 20.4195 29.4169 20.2554C29.518 20.0912 29.5267 19.8863 29.4408 19.7139L27.1771 15.2608C27.0825 15.0722 26.8901 14.9531 26.6792 14.9531H26.0943C26.111 15.1367 26.1225 15.3219 26.1225 15.5098C26.1225 17.5804 25.0866 19.4108 23.5087 20.5195Z",
    fill: "#F37AAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0566 20.5195H16.4908C14.9129 19.4108 13.8769 17.5804 13.8769 15.5098C13.8769 15.3219 13.8885 15.1367 13.9051 14.9531H13.3203C13.1094 14.9531 12.917 15.0722 12.8224 15.2608L10.5587 19.7139C10.4728 19.8863 10.4815 20.0912 10.5826 20.2554C10.6848 20.4195 10.8642 20.5195 11.0566 20.5195Z",
    fill: "#F37AAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28201_15010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(10.5 10.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSweepsColoured);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_sweeps_coloured.88dad045cd5602c5e874f1e310b11a2c.svg";